module.exports = __webpack_public_path__ + "img/legende225.e935e139.jpg";